import { render, staticRenderFns } from "./Boputu.vue?vue&type=template&id=791a9a3c&scoped=true"
import script from "./Boputu.vue?vue&type=script&lang=js"
export * from "./Boputu.vue?vue&type=script&lang=js"
import style0 from "./Boputu.vue?vue&type=style&index=0&id=791a9a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a9a3c",
  null
  
)

export default component.exports